/*
 *  Copyright 2026 LiteFarm.org
 *  This file is part of LiteFarm.
 *
 *  LiteFarm is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  LiteFarm is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 *  GNU General Public License for more details, see <https://www.gnu.org/licenses/>.
 */

import i18n from '../locales/i18n';

export const formatCropVarietyLabel = ({
  crop_variety_name,
  crop_translation_key,
}: {
  crop_variety_name?: string | null;
  crop_translation_key: string;
}) => {
  return crop_variety_name
    ? `${crop_variety_name}, ${i18n.t(`crop:${crop_translation_key}`)}`
    : i18n.t(`crop:${crop_translation_key}`);
};
